module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-100-thin-67311a0e2c02f044c9c7806b38bc2b71.woff2";